export default __webpack_public_path__ + "static/media/fish-bg-mob.a055e0f6.svg";